

export default class History {

    constructor() {
        this.undoList = [];
        this.redoList = [];
    }

    addInUndoList = (action) => {
        this.undoList.push(action);
    }
}